import React, { useMemo } from "react";
import { theme } from "uikit";

import getIconByExt from "../../../../../../utils/getIconByExt";
import Loader from "../../../../../Loader";
import Background from "../../../../../../pages/MainPage/pages/Preferences/tabs/Sectors/components/Content/components/List/components/Content/components/Group/components/Background";

import Root from "./components/Root";
import Image from "./components/Image";

const documentExtensionsForIcon = [
	"pdf",
	"doc",
	"docx",
	"xls",
	"xlsx",
	"ppt",
	"pptx",
	"txt",
	"rtf",
];

const rasterImageExtensions = new Set([
	"png",
	"jpg",
	"jpeg",
	"webp",
	"gif",
	"bmp",
]);

const Preview: React.FC<Preview.Props> = ({
	url,
	type,
	extension,
	loading,
	fit = "cover",
	onClick,
}) => {
	const content = useMemo(() => {
		const ext = extension.toLowerCase().trim();
		const shouldShowRaster =
			Boolean(url) &&
			(type.startsWith("image") || rasterImageExtensions.has(ext));

		if (shouldShowRaster) return <Image url={url} fit={fit} />;

		if (documentExtensionsForIcon.includes(ext))
			return getIconByExt(extension.toUpperCase(), {
				fill: theme.colors.secondary,
			});

		return null;
	}, [extension, fit, type, url]);

	return (
		<Root onClick={onClick}>
			<Loader active={loading} dimmed>
				<Background
					align="center"
					justify="center"
					maxedWidth
					maxedHeight
				>
					{content}
				</Background>
			</Loader>
		</Root>
	);
};

declare namespace Preview {
	interface Props {
		loading: boolean;
		url: string;
		type: string;
		extension: string;
		fit?: "cover" | "contain";

		onClick: () => void;
	}
}

export default Preview;
